<!-- Translated: skip -->
<template>
  <div :class="{component: true, disabled: loading}">

    <h1 v-if="isNew">Skapa lösenord</h1>
    <h1 v-else>Glömt lösenord</h1>

    <div v-if="!loggedIn">

      <p v-if="isNew">Ange din e-postadress nedan för att få instruktioner om hur du skapar ditt lösenord.</p>
      <p v-else>Ange din e-postadress nedan för att få instruktioner om hur du återställer ditt lösenord.</p>

      <Loading :show="loading" />
      <div>
        <label>E-postadress</label>
        <input @keyup.enter="save()" placeholder="Din e-postadress" type="email" v-model="user.email" />
      </div>
      <div class="center wide">
        <p class="error-message" v-if="errorMessage">{{errorMessage}}<br><br>Ring gästservice på <a href="tel:054-13 26 00">054-13 26 00</a> om du behöver hjälp.<br><br></p>
      </div>
      <div class="center wide">
        <button class="block" @click="save()">Begär nytt lösenord</button>
      </div>

    </div>

    <div v-if="loggedIn">

      <p>Du är redan inloggad. <router-link to="{name: 'my pages'}">Klicka här</router-link> om du vill gå till dina sidor.</p>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import API from '@/classes/API';
import Loading from '@/components/components/Loading';

export default {
  data() {
    return {
      user: {
        email: '',
      },
      loading: false,
      errorMessage: '',
    };
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters([
      'loggedIn',
      'resetPasswordSuccessMessage',
    ]),
    isNew() {
      return this.$route.name.match(/new/);
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
      'updateResetPasswordSuccessMessage',
    ]),
    async save() {
      this.loading = true;
      const data = {
        email: this.user.email,
        is_new: this.isNew,
      };

      const { success, errorMessage, successMessage } = await API.post('/account/request-reset-password', data);

      if (!success) {
        this.errorMessage = errorMessage;
      } else {
        this.errorMessage = '';
        this.updateResetPasswordSuccessMessage(successMessage);
        this.$router.push('/logga-in');
      }

      this.loading = false;
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.component
  max-width 500px
  margin 0 auto
  display flex
  flex-wrap wrap
  justify-content space-between
  padding-top 60px
  centered()
  h1
    centered()
    margin-left auto
    margin-right auto
  & > div
    width 100%
    &.wide
      width 100%
  label
    font-size 11px
    margin-bottom 0
    text-align: left

.disabled
  disabled-grey()

input
  input()
  margin-bottom 20px
  max-width 100%
  min-width 10%

.error-message
  margin-top 10px
  margin-bottom 10px
</style>



// WEBPACK FOOTER //
// RequestResetPassword.vue?b2b860a6